import React from 'react';
import { FLOW_STEP } from '../../stateManagement/engine/reducers/SessionReducer';
import IdleContent from '../IdleContent';
import CustomerInformation from '../CustomerInformation';
import AddressInformation from '../AddressInformation';
import OrderManager from '../OrderManager';
import styles from './Main.scss';
import EmptyStateHelper from '../EmptyStateHelper';
import _ from 'lodash';
import EditDishModal from '../EditDishModal';
import { Modals } from '../../utils/constants';
import CreditCardIFrame from '../CreditCardIFrame';
import BranchSelector from '../BranchSelector';
import OrderHistory from '../OrderHistory';
import UnavailableDishes from '../UnavailableDishes';
import AssociateDishModal from '../AssociateDishModal';
import OrderConfirmationModal from '../OrderConfirmationModal';
import OrderPlacementErrorModal from '../OrderPlacementErrorModal';
import Welcome from '../Welcome';
import FullScreenLoader from '../FullScreenLoader';
import CancelOrderModal from '../CancelOrderModal';
import BackToDashboardModal from '../BackToDashboardModal';
import SettingsChangedModal from '../SettingsChangedModal';
import InitWrapper from '../InitWrapper';
import BILogger from '../../utils/BILogger';
import ArrowLeftSmall from 'wix-ui-icons-common/ArrowLeftSmall';
import NavigateAwayModal from '../NavigateAwayModal';
import { FirstTimeWelcome } from '../FirstTimeWelcome/FirstTimeWelcome';
import { translate } from 'react-i18next';
import CashierWidgetModal from '../CashierWidgetModal';
import { TextButton, FontUpgrade } from 'wix-style-react';

class Main extends React.PureComponent {
  static displayName = 'Main';

  componentDidMount() {
    const { initSession } = this.props;
    initSession();

    // TEMP!
    if (typeof document !== 'undefined') {
      document.body.setAttribute('dir', 'ltr');
    }
  }

  render() {
    const { step, organization, isFirstTime, t, experiments } = this.props;
    const dir = organization.locale === 'he_IL' ? 'rtl' : 'ltr';
    const content = this._getContent();
    const modals = this._getModals();
    const emptyContent = this._getEmptyContent();
    const isOrganizationEmpty = _.isEmpty(organization);
    const backToDashboardButton = this._getBackToDashboardButton({ t });
    const isFontUpgradeActive = experiments.enabled('specs.restaurants.PhoneOrdersNewFont');

    if (isOrganizationEmpty && step !== FLOW_STEP.INIT) {
      return <FullScreenLoader />;
    }
    if (!isOrganizationEmpty && emptyContent && !isFirstTime) {
      return emptyContent;
    }

    const isOnBoarding = step === FLOW_STEP.IDLE || step === FLOW_STEP.CUSTOMER_DETAILS || step === FLOW_STEP.ADDRESS;

    const className = isFirstTime ? `${styles.root}  ${styles.first}` : styles.root;
    return (
      <FontUpgrade active={isFontUpgradeActive}>
        <div data-hook="main-app" className={className} dir={dir}>
          {isOnBoarding && backToDashboardButton}
          {content}
          {modals}
        </div>
      </FontUpgrade>
    );
  }

  _getContent() {
    const { step, goTo: goToAction, isFirstTime, setFirstTime } = this.props;
    let content;
    switch (step) {
      case FLOW_STEP.INIT:
        content = isFirstTime ? (
          <FirstTimeWelcome
            onStartClick={() => {
              setFirstTime({ value: false });
            }}
          />
        ) : (
          <Welcome onTakePhoneOrderClick={() => goToAction({ state: { step: FLOW_STEP.IDLE } })} />
        );
        break;
      case FLOW_STEP.ORDER:
      case FLOW_STEP.EDIT_DISH:
      case FLOW_STEP.CHECKOUT:
        content = <OrderManager />;
        break;
      case FLOW_STEP.CUSTOMER_DETAILS:
        content = <CustomerInformation />;
        break;
      default:
        content = this._getDetailsContent();
    }

    content = <div className={styles.content}>{content}</div>;

    return content;
  }

  _getEmptyContent() {
    const { emptyState, msid, organization } = this.props;

    if (emptyState && !_.isEmpty(organization)) {
      BILogger.callCenterEmptyState({
        errorType: emptyState,
        msid,
        organizationId: organization.id,
      });
    }

    return emptyState ? (
      <InitWrapper>
        <EmptyStateHelper goToSettings={this.props.goToSettings} type={emptyState} msid={msid} />
      </InitWrapper>
    ) : null;
  }

  _getDetailsContent() {
    const { step } = this.props;

    switch (step) {
      case FLOW_STEP.IDLE:
        return <IdleContent />;
      case FLOW_STEP.ADDRESS:
        return <AddressInformation />;
      default:
        return <div />;
    }
  }

  _onMenuClick = () => {
    const { lowResMenuShown } = this.props;
    this.props.sideMenuDisplay({ value: !lowResMenuShown });
  };

  _onBackToDashboard = () => {
    this.props.displayModal({ modal: Modals.BACK_TO_DASHBOARD });
  };

  _getModals = () => {
    const { modals } = this.props;
    return _.map(modals, this._renderModal);
  };

  _renderModal = (modal) => {
    const modals = {
      [Modals.EDIT_DISH]: EditDishModal,
      [Modals.CUSTOMER_INFORMATION]: CustomerInformation,
      [Modals.ADDRESS_INFORMATION]: AddressInformation,
      [Modals.BRANCH_SELECTOR]: BranchSelector,
      [Modals.ORDER_HISTORY]: OrderHistory,
      [Modals.UNAVAILABLE_DISHES]: UnavailableDishes,
      [Modals.CREDIT_CARD_IFRAME]: CreditCardIFrame,
      [Modals.ASSOCIATE_DISH_MODAL]: AssociateDishModal,
      [Modals.ORDER_CONFIRMATION]: OrderConfirmationModal,
      [Modals.ORDER_PLACEMENT_ERROR]: OrderPlacementErrorModal,
      [Modals.CANCEL_ORDER]: CancelOrderModal,
      [Modals.BACK_TO_DASHBOARD]: BackToDashboardModal,
      [Modals.SETTINGS_CHANGED]: SettingsChangedModal,
      [Modals.NAVIGATE_AWAY]: NavigateAwayModal,
      [Modals.CASHIER_WIDGET_MODAL]: CashierWidgetModal,
    };
    const ModalComponent = modals[modal];
    return <ModalComponent key={modal} isModal isOpen onRequestClose={() => this.props.hideModal({ modal })} />;
  };

  _getBackToDashboardButton({ t }) {
    return (
      <div className={styles.backToDashboard}>
        <TextButton
          prefixIcon={
            <div className={styles.backToDashboardArrow}>
              <ArrowLeftSmall />
            </div>
          }
          skin="dark"
          dataHook="top-bar-back-to-dashboard"
          onClick={this._onBackToDashboard}
        >
          {t('phoneordering_customerinfo_header_back')}
        </TextButton>
      </div>
    );
  }
}

export default translate()(Main);
